import BinCard from "@/components/bin-card";
import CardSkeleton from "@/components/skeletons/card-skeleton";
import { useGetBIN } from "@/hooks/use-queries";

export const binCards = [
  {
    id: 1,
    name: "Card 1",
    image: "https://example.com/card1.jpg",
    price: 25,
    bin: "5371 0000 0000 0000",
    binValue: "537100",
  },
];
const Shop = () => {
  const { isLoading: binsLoading } = useGetBIN();

  return (
    <div>
      {/* header */}
      <header className="flex items-center justify-between">
        <div>
          <p className="text-lg">Shop</p>
          <p className="text-3xl leading-4 font-bold">Virtual Cards</p>
        </div>
      </header>

      <h2 className="mt-4 text-base font-medium lg:text-lg">Note</h2>
      <p className="text-primary-500/40 text-sm lg:text-lg lg:leading-6">
        The card is applicable to most online consumption scenarios (ChatGPT,
        Cloudflare, Tiktok, Wechat/Allpay, Telegram, Facebook, Google and more).
        However, there may be some scenarios or payment terminals where the
        cards will not work, this will be due to the merchant’s payment
        processor
      </p>

      <div className="mt-6 grid w-full grid-cols-1 place-items-center gap-4 md:grid-cols-2 lg:grid-cols-3">
        {binsLoading
          ? [1, 2, 3].map((_, index) => <CardSkeleton key={index} />)
          : binCards?.map((card, index) => <BinCard card={card} key={index} />)}
      </div>
    </div>
  );
};

export default Shop;
